import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZMaster4B: IAbstractModule = {
  type: IModuleType.masterZ4,
  name: 'Z Master 4 B (11-14)',
  hasScreen: true,
  columns: [
    [
      {
        name: "1",
        connector: "11",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "2",
        connector: "12",
        cell_size_id: 2,
        accessible: true,
      },
      {
        name: "3",
        connector: "13",
        cell_size_id: 4,
        accessible: true,
      },
      {
        name: "4",
        connector: "14",
        cell_size_id: 4,
        accessible: false,
      },
    ],
  ]
};
